import { createPortal } from 'react-dom'

import { Toast } from './Toast'
import styles from './ToastContainer.module.css'

import type { ToastType } from './Toast'

export interface ToastItem {
  id: string
  type: ToastType
  message: string
  duration?: number
}

export interface ToastContainerProps {
  toasts: ToastItem[]
  onClose: (id: string) => void
}

export function ToastContainer({ toasts, onClose }: ToastContainerProps) {
  if (typeof document === 'undefined') {
    return null
  }

  if (toasts.length === 0) {
    return null
  }

  return createPortal(
    <div className={styles.container} role="region" aria-label="Notifications">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          message={toast.message}
          duration={toast.duration}
          onClose={onClose}
        />
      ))}
    </div>,
    document.body
  )
}
